import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { fromURL } from "image-resize-compress";
import watermark from "watermarkjs";

export function UsePictures(props) {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  const getPictureList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_ProductImages?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
        response.data.resault.images.map((model) => {
          model.id = model.productID;
          return model;
        });
      }
    });
  };

  const getAllBrandList = (callback) => {
    MyAxios.get(`Admin_ProductImages?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getPictureByID = (id, callback) => {
    MyAxios.get(`Admin_ProductImages/GetProductImageById/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateBrand = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_ProductImages`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("برند با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deletePicture = (id, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(id));
    MyAxios.delete(`Admin_ProductImages`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("عکس با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const resize = (file900, imgUrl, stateUp, callback) => {
    const format = "jpeg";
    let divist;
    let sad;
    let panjah;
    let nohsad;
    let watermarkSize;
    // const p250 = new Promise((resolve, reject) => {
    //   fromURL(imgUrl, 99, 250, 250, format).then((blob) => {
    //     divist = new File([blob], "oneFile250.jpg");
    //     resolve();
    //   });
    // });

    // const p125 = new Promise((resolve, reject) => {
    //   fromURL(imgUrl, 99, 125, 125, format).then((blob) => {
    //     sad = new File([blob], "oneFile125.jpg");
    //     resolve();
    //   });
    // });

    // const p50 = new Promise((resolve, reject) => {
    //   fromURL(imgUrl, 99, 50, 50, format).then((blob) => {
    //     panjah = new File([blob], "oneFile50.jpg");
    //     resolve();
    //   });
    // });

    const watermark900 = new Promise((resolve, reject) => {
      fromURL(imgUrl, 97, 900, 900, format).then((blob) => {
        nohsad = new File([blob], "oneFile900.jpg");
        resolve();
      });
      // watermark([file900, window.ENV.watermark])
      //   .blob(watermark.image.center())
      //   .then(function (blob) {
      //     watermarkSize = new File([blob], "oneFile900.jpg");
      //     let url = URL.createObjectURL(watermarkSize);

      //   });
    });

    Promise.all([watermark900]).then((values) => {
      const data = new FormData();
      data.append("Content", JSON.stringify(stateUp));
      if (file900) {
        data.append("image1", nohsad);
        // data.append("image2", divist);
        // data.append("image3", sad);
        // data.append("image4", panjah);
      }
      MyAxios.post(`Admin_ProductImages`, data, {}).then((response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("عکس با موفقیت ادیت شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      });
    });
  };

  const resize2 = (file900, imgUrl, stateUp, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(stateUp));

    if (file900) {
      data.append("image1", file900);
    }
    MyAxios.post(`Admin_ProductImages`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("عکس با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const post360 = (file900, imgUrl, stateUp, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(stateUp));

    MyAxios.post(`Admin_ProductImages`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("عکس با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };
  return {
    getPictureList,
    getAllBrandList,
    getPictureByID,
    updateBrand,
    deletePicture,
    resize,
    resize2,
    post360,
  };
}
